export default __webpack_public_path__ + "d7.png";